// Capitalize first letter of keys utility types
type CapitaliseFirstLetter<T extends string> = T extends `${infer F}${infer R}`
    ? `${Uppercase<F>}${R}`
    : T;

type CapitalisedKeys<T> = {
    [K in keyof T as CapitaliseFirstLetter<string & K>]: T[K];
};

export function capitaliseKeys<T extends Record<string, any>>(obj: T): CapitalisedKeys<T> {
    const result: Record<string, any> = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            result[capitalizedKey] = obj[key];
        }
    }

    return result as CapitalisedKeys<T>;
}
